// =============================================================================
// FILE: src/modules/pms/services/taskMaterialService.js
// =============================================================================

import axiosClient from "../../../api/axiosClient";


// =============================================================================
// GET BOM MATERIALS FOR TASK
// =============================================================================
export const getTaskBOMMaterials = (taskId) => {

  return axiosClient.get(
    `/api/pms/task-material/task/${taskId}/bom-materials`
  );
};


// =============================================================================
// ALLOCATE BOM MATERIALS TO TASK
// =============================================================================
export const allocateBOMMaterialsToTask = (
  taskId,
  materials
) => {

  return axiosClient.post(
    `/api/pms/task-material/task/${taskId}/allocate`,
    {
      materials
    }
  );
};


// =============================================================================
// GET TASK MATERIAL PLAN
// =============================================================================
export const getTaskMaterialPlan = (taskId) => {

  return axiosClient.get(
    `/api/pms/task-material/task/${taskId}`
  );
};


// =============================================================================
// UPDATE TASK MATERIAL
// =============================================================================
export const updateTaskMaterialQty = (
  taskMaterialPlanId,
  data
) => {

  return axiosClient.put(
    `/api/pms/task-material/update/${taskMaterialPlanId}`,
    data
  );
};


// =============================================================================
// DELETE TASK MATERIAL
// =============================================================================
export const deleteTaskMaterial = (
  taskMaterialPlanId
) => {

  return axiosClient.delete(
    `/api/pms/task-material/delete/${taskMaterialPlanId}`
  );
};


// =============================================================================
// CREATE MANUAL MATERIAL
// =============================================================================
export const createManualMaterial = (
  taskId,
  data
) => {

  return axiosClient.post(
    `/api/pms/task-material/task/${taskId}/manual-material`,
    data
  );
};